import React from 'react'

export default function LoaderComponent() {
    return (
        <div className="loaderSuspense">
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}
